<template>
    <div :class="'tt-tool ' + (Active ? 'toggled' : '')" @click="Clicked()">
        <img style="width:24px;" :src="svgUrl" alt="SVG Image" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            svgUrl: '/images/icons/tiptap/' + this.KnownIcon + ".svg"
        };
    },
    methods:{
        Clicked(){
            this.$emit('ToolClick'); 
        }
    },
    props: [
        "KnownIcon",
        "Editor",
        "Command",
        "Active",
        "Disabled",
        "CommandDescription",
        "Size"
    ]
}
</script>
<style>
.tt-tool {
    width: 32px;
    height: 32px;
    display: inline-block;
    line-height: 50px;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
}

.tt-tool.toggled {
    /* background:#efefef; */
    /* border:1px solid gray; */
    background: #efefef;
    border-radius: 5px;
}
</style>